import { render, staticRenderFns } from "./KarmaRequestEdit.vue?vue&type=template&id=4d7b94c6&"
import script from "./KarmaRequestEdit.vue?vue&type=script&lang=js&"
export * from "./KarmaRequestEdit.vue?vue&type=script&lang=js&"
import style0 from "./KarmaRequestEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports